(function () {
  if (window.ScrollCollectionInitialized) return;
  window.ScrollCollectionInitialized = true;

  const MOBILE_BREAKPOINT = 750;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function initSection(grid) {
    const sectionId = grid.dataset.sectionId;
    const viewMoreBtn = document.getElementById('ViewMore-' + sectionId);
    const viewMoreContainer = document.getElementById('ViewMoreContainer-' + sectionId);

    const totalProducts = parseInt(grid.dataset.totalProducts);
    const viewAllUrl = grid.dataset.viewAllUrl;
    const loadBehavior = grid.dataset.loadBehavior;
    const initialDesktop = parseInt(grid.dataset.initialDesktop);
    const initialMobile = parseInt(grid.dataset.initialMobile);
    const perLoadDesktop = parseInt(grid.dataset.productsPerLoadDesktop);
    const perLoadMobile = parseInt(grid.dataset.productsPerLoadMobile);

    const allItems = Array.from(grid.querySelectorAll('.grid__item'));

    let productsVisible = 0;
    let scrollListenerAttached = false;
    let ticking = false;
    let wasMobile = isMobile();

    function getInitial() {
      return isMobile() ? initialMobile : initialDesktop;
    }

    function getPerLoad() {
      return isMobile() ? perLoadMobile : perLoadDesktop;
    }

    function showItems(targetCount) {
      const end = Math.min(targetCount, allItems.length, totalProducts);
      for (let i = productsVisible; i < end; i++) {
        allItems[i].classList.remove('hidden');
      }
      productsVisible = end;
      updateButton();
    }

    function updateButton() {
      if (!viewMoreBtn || !viewMoreContainer) return;

      if (productsVisible >= totalProducts || productsVisible >= allItems.length) {
        viewMoreBtn.textContent = 'View All';
        viewMoreBtn.onclick = function () {
          window.location.href = viewAllUrl;
        };
        viewMoreContainer.classList.remove('hidden');
      } else if (loadBehavior === 'click') {
        viewMoreBtn.textContent = 'View More';
        viewMoreBtn.onclick = loadMore;
        viewMoreContainer.classList.remove('hidden');
      } else {
        viewMoreContainer.classList.add('hidden');
      }
    }

    function loadMore() {
      showItems(productsVisible + getPerLoad());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (productsVisible >= totalProducts) return;
        var lastVisible = allItems[productsVisible - 1];
        if (!lastVisible) return;
        var rect = lastVisible.getBoundingClientRect();
        if (rect.bottom - window.innerHeight < 200) {
          loadMore();
        }
      });
    }

    function attachScrollListener() {
      if (!scrollListenerAttached && loadBehavior === 'scroll') {
        window.addEventListener('scroll', onScroll, { passive: true });
        scrollListenerAttached = true;
      }
    }

    function initVisible() {
      productsVisible = 0;
      allItems.forEach(function (el) {
        if (!el.classList.contains('hidden')) {
          productsVisible++;
        }
      });
      updateButton();
    }

    function reset() {
      allItems.forEach(function (el) {
        el.classList.add('hidden');
      });
      productsVisible = 0;
      showItems(getInitial());
      attachScrollListener();
    }

    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile !== wasMobile) {
        wasMobile = nowMobile;
        reset();
      }
    }, { passive: true });

    initVisible();
    attachScrollListener();
  }

  function initAll() {
    document.querySelectorAll('.scroll-collection-grid').forEach(function (grid) {
      initSection(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var grid = event.target.querySelector('.scroll-collection-grid');
    if (grid) initSection(grid);
  });

})();